
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fullcoveragewarranty",
      function () {
        return require("private-next-pages/fullcoveragewarranty/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fullcoveragewarranty"])
      });
    }
  